import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';

const OnlyWithOrderReferenceSchema = Yup.object().shape({
  orderReference: Yup.string().required(globalMessages.form.required),
});

export default OnlyWithOrderReferenceSchema;
